import * as Type from './actionsTypes';

const login = (authData, callback, options = {}) => ({
  type: Type.FETCH_AUTH,
  authData,
  callback,
  options,
});

const loginMicrosoft = (microsoftAuth, callback) => ({
  type: Type.FETCH_AUTH_MICROSOFT,
  microsoftAuth,
  callback,
});

const forgotPassword = forgotData => ({ type: Type.FETCH_FORGOT_PASSWORD, forgotData });

const updatePassword = (id, data, callback, showMessage) => ({ type: Type.UPDATE_PASSWORD, id, data, callback, showMessage });

const updateProfile = data => ({ type: Type.UPDATE_PROFILE, data });

const logout = history => ({ type: Type.AUTH_LOGOUT, history });

const clearUpdatePasswordFlag = () => ({ type: Type.AUTH_CLEAR_UPDATE_PASSWORD });

export {
  login,
  loginMicrosoft,
  forgotPassword,
  updatePassword,
  updateProfile,
  logout,
  clearUpdatePasswordFlag,
}